import ApiBase from '../ApiBase';

class ScheduledReports extends ApiBase {
    route = '/admin/scheduled-reports';

    /**
     * @method sendToMe
     * @return {Promise<*>}
     */
    sendToMe = (id) => {
        return this.get(this.route + '/send-to-me/' + id);
    };

    /**
     * @method sendNow
     * @return {Promise<*>}
     */
    sendNow = (id) => {
        return this.get(this.route + '/send-now/' + id);
    };
}

export default new ScheduledReports();
